// Tko je doveo kojeg igrača (vlasnik 19. 10. 2026., „u pozadini”): poveznice koje igrač dijeli nose ?inv=<njegov kod>.
// Kod se zapamti pri dolasku (30 dana, i kad se registracija dogodi tek kasnije ili preko Googlea), a nakon prve prijave
// pošalje se jednom (POST /v1/me/invite); baza ga upiše samo novom računu (do 1 dan) koji još nema preporučitelja, a pozivatelj dobije obavijest.
import { useEffect } from 'react';

const KEY = 'lobi-inv';
const DAYS30 = 30 * 86_400_000;

/** pri otvaranju: ?inv= iz adrese (poziv iz WhatsAppa, dijeljeni meč) */
export function captureInvite() {
  try {
    const code = new URLSearchParams(location.search).get('inv')?.trim().toUpperCase();
    if (code && /^[A-Z0-9]{3,20}$/.test(code)) localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }));
  } catch {
    /* privatni prozor: bez preporuke */
  }
}

/** moja poveznica s kodom (za dijeljenje) */
export const withInvite = (url: string, code: string | null | undefined) => {
  if (!code) return url;
  const u = new URL(url);
  u.searchParams.set('inv', code);
  return u.toString();
};

const readSaved = (): { code?: string; at?: number } | null => {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? 'null') as { code?: string; at?: number } | null;
  } catch {
    return null;
  }
};

/** zapamćeni kod (za prelazak iz Facebookova preglednika u Chrome, inApp.ts) */
export const savedInvite = () => {
  const s = readSaved();
  return s?.code && s.at && Date.now() - s.at < DAYS30 ? s.code : null;
};

/** prijavljen igrač: zapamćeni kod se pošalje jednom, pa zaboravi */
export function useClaimInvite(me: string | null) {
  useEffect(() => {
    if (!me) return;
    const saved = readSaved();
    if (!saved?.code) return;
    const forget = () => {
      try {
        localStorage.removeItem(KEY);
      } catch {
        /* ništa */
      }
    };
    if (!saved.at || Date.now() - saved.at > DAYS30) return forget();
    void fetch('/v1/me/invite', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ code: saved.code }),
    })
      .then(r => {
        if (r.ok || r.status === 400) forget(); // upisano ili odbijeno (star račun, nepoznat kod): više se ne pokušava
      })
      .catch(() => {}); // bez mreže: idući put
  }, [me]);
}
